import { TabbedInterface } from "../../../components/layout/tabbed-interface/TabbedInterface";
import { useTranslation } from "../../../hooks/useTranslation";
import { AmazonNotificationSettings } from "./AmazonNotificationSettings";
import { ForwardedMailsList } from "./ForwardedMailsList";
import { MailForwardInstructions } from "./MailForwardInstructions";

const tabs = [
  {
    label: "mailForwardInstructions",
    path: "forward-instructions",
    component: <MailForwardInstructions />,
  },
  {
    label: "forwardedMailsList",
    path: "forwarded-mails",
    component: <ForwardedMailsList />,
  },
  {
    label: "amazonNotificationSettings",
    path: "notification-settings",
    component: <AmazonNotificationSettings />,
  },
];

export const MailNotificationSettings = () => {
  const { translate } = useTranslation("pages.stores.mailNotification.tabs");

  return (
    <TabbedInterface
      tabs={tabs}
      defaultPath="mailForwardInstructions"
      translate={translate}
    />
  );
};
